import { MIN_WAGE_BAL_HDR, MIN_WAGE_HDR, minWageBalanceCells, minWageCells, money } from "@/lib/payrollView";

// CC-156: minimum-wage supplement for commission techs (pay weeks from 2026-10-12).
export function MinWageSection({ mw }) {
  if (!mw || !Object.keys(mw).length) return null;
  const rows = mw.rows || [];
  return (
    <div className="bg-white border border-[#e7e9ee] rounded-xl overflow-x-auto" data-testid="payroll-min-wage-section">
      <div className="px-5 py-3 border-b border-[#eef1f6] flex items-center gap-3">
        <span className="font-display font-semibold text-[15px]">Minimum-wage supplement</span>
        <span className="font-mono-data text-[12px]" data-testid="payroll-min-wage-total">{money(mw.supplement_total)}</span>
        <span className="text-[11px] text-[color:var(--cc-ink-muted)]">MO {money(mw.rate)}/h · effective {mw.effective_from} · paid hours = Working + Driving + Meeting (Break, Lunch, other excluded)</span>
      </div>
      {!mw.hours_file_present && (
        <div className="px-5 py-2 text-[12px] text-[#7a1c1c] bg-[#fdecec]" data-testid="payroll-min-wage-missing">
          No st_hours file uploaded — the floor is not checked. Approval is blocked (MIN_WAGE_HOURS_MISSING); preview still runs.
        </div>
      )}
      {rows.length > 0 && (
        <table className="w-full text-[12px]" data-testid="payroll-min-wage-table">
          <thead className="bg-[#f5f6f8] text-[10.5px] uppercase tracking-[.08em] text-[color:var(--cc-ink-muted)]">
            <tr>{MIN_WAGE_HDR.map((h) => <th key={h} className="text-left py-2 px-3">{h}</th>)}</tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.person_id} className="border-t border-[#eef1f6]" data-testid={`payroll-min-wage-row-${r.person_id}`}>
                {minWageCells(r).map((c, i) => <td key={i} className={`py-1.5 px-3 ${i ? "font-mono-data" : ""}`}>{c}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      )}
      <MinWageBalances mw={mw} />
    </div>
  );
}

function MinWageBalances({ mw }) {
  const rows = mw.balances || [];
  if (!rows.length) return null;
  return (
    <div className="border-t border-[#eef1f6]" data-testid="payroll-min-wage-balances">
      <div className="px-5 py-2 text-[12px] flex items-center gap-3">
        <span className="font-semibold">Minimum-wage balance</span>
        <span className="font-mono-data" data-testid="payroll-min-wage-recovery-total">recovered this week {money(mw.recovery_total)}</span>
        <span className="text-[11px] text-[color:var(--cc-ink-muted)]">Recovery never takes a tech under that week's floor · balance changes only when the run is approved</span>
      </div>
      <table className="w-full text-[12px]" data-testid="payroll-min-wage-balances-table">
        <thead className="bg-[#f5f6f8] text-[10.5px] uppercase tracking-[.08em] text-[color:var(--cc-ink-muted)]">
          <tr>{MIN_WAGE_BAL_HDR.map((h) => <th key={h} className="text-left py-2 px-3">{h}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((b) => (
            <tr key={b.person_id} className="border-t border-[#eef1f6]" data-testid={`payroll-min-wage-balance-row-${b.person_id}`}>
              {minWageBalanceCells(b).map((c, i) => <td key={i} className={`py-1.5 px-3 ${i ? "font-mono-data" : ""}`}>{c}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
